import React, { Component } from 'react';
import classes from './PersonalForm.module.scss';
import cx from 'classnames';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

import cityIcon from '../../../assets/images/icons/city-icon.png';
import zipIcon from '../../../assets/images/icons/zip-icon.png';

class PersonalForm extends Component {
  constructor(props) {
    super(props);
    this.phone = React.createRef();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState !== this.state) {
      this.props.onChangePersonalForm(this.state);
    }
  }
  state = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    state: '',
    city: '',
    zip: ''
  };

  formatPhoneNumber = phoneNumberString => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? '+1 ' : '';
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return '';
  };
  formatPhone = e => {
    this.setState({
      phone: this.formatPhoneNumber(e.target.value)
    });
  };
  updateInputValue = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };
  render() {
    const options = [
      { value: 'Maryland', label: 'Maryland' },
      { value: 'Virginia', label: 'Virginia' },
      { value: 'Washington DC', label: 'Washington, DC' },
      { value: 'Alabama', label: 'Alabama' },
      { value: 'Alaska', label: 'Alaska' },
      { value: 'Arizona', label: 'Arizona' },
      { value: 'Arkansas', label: 'Arkansas' },
      { value: 'California', label: 'California' },
      { value: 'Colorado', label: 'Colorado' },
      { value: 'Connecticut', label: 'Connecticut' },
      { value: 'Delaware', label: 'Delaware' },
      { value: 'Florida', label: 'Florida' },
      { value: 'Georgia', label: 'Georgia' },
      { value: 'Hawaii', label: 'Hawaii' },
      { value: 'Idaho', label: 'Idaho' },
      { value: 'Illinois', label: 'Illinois' },
      { value: 'Indiana', label: 'Indiana' },
      { value: 'Iowa', label: 'Iowa' },
      { value: 'Kansas', label: 'Kansas' },
      { value: 'Kentucky', label: 'Kentucky' },
      { value: 'Louisiana', label: 'Louisiana' },
      { value: 'Maine', label: 'Maine' },
      { value: 'Massachusetts', label: 'Massachusetts' },
      { value: 'Michigan', label: 'Michigan' },
      { value: 'Minnesota', label: 'Minnesota' },
      { value: 'Mississippi', label: 'Mississippi' },
      { value: 'Missouri', label: 'Missouri' },
      { value: 'Montana', label: 'Montana' },
      { value: 'North Carolina', label: 'North Carolina' },
      { value: 'North Dakota', label: 'North Dakota' },
      { value: 'Nebraska', label: 'Nebraska' },
      { value: 'Nevada', label: 'Nevada' },
      { value: 'New Hampshire', label: 'New Hampshire' },
      { value: 'New Jersey', label: 'New Jersey' },
      { value: 'New Mexico', label: 'New Mexico' },
      { value: 'New York', label: 'New York' },
      { value: 'Ohio', label: 'Ohio' },
      { value: 'Oklahoma', label: 'Oklahoma' },
      { value: 'Oregon', label: 'Oregon' },
      { value: 'Pennsylvania', label: 'Pennsylvania' },
      { value: 'Puerto Rico', label: 'Puerto Rico' },
      { value: 'Rhode Island', label: 'Rhode Island' },
      { value: 'South Carolina', label: 'South Carolina' },
      { value: 'South Dakota', label: 'South Dakota' },
      { value: 'Tennessee', label: 'Tennessee' },
      { value: 'Texas', label: 'Texas' },
      { value: 'Utah', label: 'Utah' },
      { value: 'Vermont', label: 'Vermont' },
      { value: 'Washington', label: 'Washington' },
      { value: 'West Virginia', label: 'West Virginia' },
      { value: 'Wisconsin', label: 'Wisconsin' },
      { value: 'Wyoming', label: 'Wyoming' }
    ];

    return (
      <div className={classes.PersonalForm}>
        <div className={classes.formRow}>
          <div className={classes.formHalf}>
            <i
              className={cx(classes.formIcon, 'fa fa-user')}
              aria-hidden="true"
            ></i>
            <input
              name="firstName"
              type="text"
              placeholder="First Name"
              maxLength="30"
              onChange={e => this.updateInputValue(e)}
            />
          </div>
          <div className={classes.formHalf}>
            <i
              className={cx(classes.formIcon, 'fa fa-user')}
              aria-hidden="true"
            ></i>
            <input
              name="lastName"
              type="text"
              placeholder="Last Name"
              maxLength="30"
              value={this.state.lastName}
              onChange={e => this.updateInputValue(e)}
            />
          </div>
        </div>
        <div className={classes.formRow}>
          <div className={classes.formHalf}>
            <i
              className={cx(classes.formIcon, 'fa fa-envelope')}
              aria-hidden="true"
            ></i>
            <input
              name="email"
              type="email"
              placeholder="Email Address"
              value={this.state.email}
              onChange={e => this.updateInputValue(e)}
            />
          </div>
          <div className={classes.formHalf}>
            <i
              className={cx(classes.formIcon, 'fa fa-map-marker')}
              aria-hidden="true"
            ></i>
            <input
              name="address"
              type="text"
              placeholder="Address"
              maxLength="120"
              value={this.state.address}
              onChange={e => this.updateInputValue(e)}
            />
          </div>
        </div>
        <div className={classes.formRow}>
          <div className={classes.formHalf}>
            <i className={cx(classes.formIcon)} aria-hidden="true">
              <img src={cityIcon} alt="" />
            </i>
            <input
              name="city"
              type="text"
              placeholder="City"
              maxLength="120"
              value={this.state.city}
              onChange={e => this.updateInputValue(e)}
            />
          </div>
          <div className={classes.formHalf}>
            <i className={cx(classes.formIcon)} aria-hidden="true">
              <img src={zipIcon} alt="" />
            </i>
            <input
              name="zip"
              type="text"
              placeholder="ZIP Code"
              maxLength="5"
              value={this.state.zip}
              onChange={e => this.updateInputValue(e)}
            />
          </div>
        </div>
        <div className={classes.formRow}>
          <div className={classes.formHalf}>
            <i
              className={cx(classes.formIcon, 'fa fa-phone')}
              aria-hidden="true"
            ></i>
            <input
              name="phone"
              type="text"
              maxLength="10"
              placeholder="Phone Number"
              ref={this.phone}
              value={this.state.phone}
              onChange={e => this.updateInputValue(e)}
              onBlur={e => this.formatPhone(e)}
            />
          </div>
          <div className={classes.formHalf}>
            <i
              className={cx(classes.formIcon, 'fa fa-building')}
              aria-hidden="true"
            ></i>

            <Dropdown
              name="state"
              options={options}
              onChange={e =>
                this.setState({
                  state: e.value
                })
              }
              value={this.state.state}
              placeholder="State"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default PersonalForm;
